export default __webpack_public_path__ + "static/media/bar-expenses.e6405263.svg";